:host,
:host *,
:host *::after,
:host *::before {
  box-sizing: border-box;
}

#app-link {
  display: flex;
  height: 48px;
  padding: 4px 0;
  cursor: pointer;
  position: relative;
}

#app-link::after {
  content: '';
  display: block;
  position: absolute;
  top: 4px;
  right: 0;
  bottom: 4px;
  left: 0;
  border-radius: 4px;
  background: var(--grid-content-primary);
  opacity: 0;
  transition: opacity var(--duration-medium-1) var(--curve-expressive-ease-in-out);
}

#app-link:hover::after {
  opacity: 0.05;
  transition: opacity var(--duration-fast) var(--curve-simple-ease-out);
}

#app-link img {
  max-height: 100%;
}
